
  (function () {
    'use strict';
    var root = document.getElementById('rv-template--21324002590810__banisti_reviews_xXacVT');
    if (!root || root.dataset.on) return;
    root.dataset.on = '1';

    var grid = root.querySelector('[data-rv-grid]');
    var dataEl = root.querySelector('[data-rv-data]');
    if (!grid || !dataEl) return;

    var moreWrap = root.querySelector('[data-rv-more]');
    var loadBtn = root.querySelector('[data-rv-load]');
    var shownEl = root.querySelector('[data-rv-shown]');
    var totalEl = root.querySelector('[data-rv-total]');
    var emptyEl = root.querySelector('[data-rv-empty]');
    var dd = root.querySelector('[data-rv-dd]');
    var ddBtn = root.querySelector('[data-rv-ddbtn]');
    var ddPanel = root.querySelector('[data-rv-panel]');
    var ddLabel = root.querySelector('[data-rv-ddlabel]');
    var lb = root.querySelector('[data-rv-lb]');
    var lbImg = root.querySelector('[data-rv-lbimg]');

    var ALL = [];
    try { ALL = JSON.parse(dataEl.textContent) || []; } catch (e) { return; }
    ALL.forEach(function (r, k) { r._k = k; });

    var STEP = parseInt(root.dataset.step, 10) || 8;
    var LOAD_MS = parseInt(root.dataset.delay, 10) || 0;
    var INITIAL = parseInt(root.dataset.initial, 10) || 8;
    var CFG = {
      img: true,
      av: true,
      ver: true,
      date: true,
      verTxt: "Compra verificada",
      starsW: "estrellas",
      zoom: "Ampliar imagen",
      base: "Más relevantes",
      rel: true,
      rateNum: true
    };
    var D = {
      today: "Hoy",
      yesterday: "Ayer",
      days: "Hace {n} días",
      week: "Hace una semana",
      weeks: "Hace {n} semanas",
      month: "Hace un mes",
      months: "Hace {n} meses",
      year: "Hace un año",
      years: "Hace {n} años"
    };

    var F = {
      mineTag: "Tu reseña",
      editLabel: "Editar",
      ctaLabel: "Añadir reseña",
      editCta: "Editar mi reseña",
      verTxt: "Compra verificada",
      notPicked: "Sin seleccionar",
      anonName: "Cliente",
      sendReal: true,
      subject: "Nueva reseña desde la web",
      newTitle: "¿Qué te ha parecido el producto?",
      editTitle: "Actualizar tu reseña",
      submitBtn: "Enviar reseña",
      updateBtn: "Actualizar reseña",
      sendingTxt: "Enviando reseña",
      sentTxt: "¡Enviado!",
      updatedTxt: "¡Actualizado!",
      sendMs: 1900,
      doneMs: 1000
    };
    var KEY = 'rv-mine-' + (root.dataset.pid || 'site');
    var mine = null;
    try { mine = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { mine = null; }

    function applyMine() {
      ALL = ALL.filter(function (r) { return !r._mine; });
      if (mine && mine.t) {
        var m = { n: mine.n, d: mine.d, r: mine.r, i: '', h: mine.h, t: mine.t, _mine: true, _k: -1 };
        ALL.unshift(m);
      }
      ALL.forEach(function (r, k) { if (!r._mine) r._k = k; });
    }
    applyMine();
    var hasMine = !!(mine && mine.t);

    var filter = '0';
    var sort = 'd';
    var visible = INITIAL;

    function relDate(v) {
      if (!CFG.rel || !v) return v || '';
      var t = Date.parse(v);
      if (isNaN(t)) return v;
      var dd = Math.floor((Date.now() - t) / 86400000);
      if (dd < 0) return v;
      if (dd < 1) return D.today;
      if (dd === 1) return D.yesterday;
      if (dd < 7) return D.days.replace('{n}', dd);
      if (dd < 14) return D.week;
      if (dd < 30) return D.weeks.replace('{n}', Math.floor(dd / 7));
      if (dd < 60) return D.month;
      if (dd < 365) return D.months.replace('{n}', Math.floor(dd / 30));
      if (dd < 730) return D.year;
      return D.years.replace('{n}', Math.floor(dd / 365));
    }

    function esc(v) {
      if (v === null || v === undefined) return '';
      return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function match(r) {
      if (filter === '0') return true;
      if (filter === 'p') return !!r.i;
      if (filter === '3') return r.r <= 3;
      return r.r === parseInt(filter, 10);
    }
    function order(a, b) {
      /* הביקורת של המשתמש ראשונה, אחריה הנעוצות */
      var am = a._mine ? 2 : (a.p ? 1 : 0);
      var bm = b._mine ? 2 : (b.p ? 1 : 0);
      if (am !== bm) return bm - am;
      if (sort === 'h') return b.r - a.r || a._k - b._k;
      if (sort === 'l') return a.r - b.r || a._k - b._k;
      if (sort === 'p') return (b.i ? 1 : 0) - (a.i ? 1 : 0) || a._k - b._k;
      return a._k - b._k;
    }
    function stars(n) {
      var out = '<span class="rv__stars" aria-label="' + n + ' ' + esc(CFG.starsW) + '">';
      for (var i = 1; i <= 5; i++) {
        out += '<svg viewBox="0 0 24 24"' + (i <= n ? ' class="on"' : '') +
          ' aria-hidden="true"><path d="M12 2.2l3 6.1 6.7 1-4.9 4.7 1.2 6.7-6-3.2-6 3.2 1.2-6.7L2.3 9.3l6.7-1z"/></svg>';
      }
      if (CFG.rateNum) out += '<em class="rv__rn">' + n + '/5</em>';
      return out + '</span>';
    }
    function card(r, idx) {
      var mine = !!r._mine;
      var h = '<article class="rv__card' + (mine ? ' rv__card--mine' : '') + '" data-rate="' + r.r +
        '" data-photo="' + (r.i ? 1 : 0) + '">';
      if (mine) {
        h += '<span class="rv__mine-tag"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" ' +
          'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>' +
          esc(F.mineTag) + '</span>';
      }
      h += '<div class="rv__top">';
      h += '<span class="rv__id"><span class="rv__name">';
      if (CFG.av) {
        var nm = String(r.n || '');
        var av = (nm.length + idx + 1) % 10;
        h += '<span class="rv__av rv__av--' + av + '" aria-hidden="true">' +
          esc(nm.charAt(0)) + '</span>';
      }
      h += esc(r.n);
      h += '</span><span class="rv__meta">';
      if (CFG.ver && CFG.verTxt) {
        h += '<span class="rv__ver">' + esc(CFG.verTxt) +
          '<svg class="rv__vi" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="currentColor"/>' +
          '<path d="M7.6 12.3l3 3 5.8-6" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
      }
      if (CFG.date && r.d) h += '<span class="rv__date">' + esc(relDate(r.d)) + '</span>';
      h += '</span></span></div>' + stars(r.r);
      if (r.h) h += '<h3 class="rv__h">' + esc(r.h) + '</h3>';
      if (r.t) h += '<p class="rv__text">' + esc(r.t) + '</p>';
      if (CFG.img && r.i) {
        h += '<button type="button" class="rv__thumb" data-rv-zoom="' + esc(r.i) + '" aria-label="' + esc(CFG.zoom) +
          '"><img src="' + esc(r.i) + '" alt="' + esc(r.n) + '" width="300" height="300" loading="lazy" decoding="async"></button>';
      }
      if (mine) {
        h += '<button type="button" class="rv__edit" data-rv-open><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
          'stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>' + esc(F.editLabel) + '</button>';
      }
      return h + '</article>';
    }
    function current() { return ALL.filter(match).sort(order); }

    /* ── Masonry מבוסס Grid ──
       קודם מודדים את גובה הכרטיסים בגריד רגיל, ואז נותנים לכל כרטיס span מתאים.
       כך סדר הכרטיסים נשאר משמאל/ימין לפי שורות ולא כל התמונות נערמות בעמודה אחת. */
    var masonryFrame = 0;
    function layoutMasonry() {
      if (!grid) return;
      if (masonryFrame) cancelAnimationFrame(masonryFrame);
      masonryFrame = requestAnimationFrame(function () {
        masonryFrame = 0;
        var cards = Array.prototype.slice.call(grid.children);
        if (!cards.length) {
          grid.classList.remove('rv__grid--masonry');
          return;
        }

        /* מצב מדידה רגיל מונע חפיפה בזמן חישוב הגבהים. */
        grid.classList.remove('rv__grid--masonry');
        cards.forEach(function (el) { el.style.gridRowEnd = ''; });

        var cs = window.getComputedStyle(grid);
        var gap = parseFloat(cs.rowGap || cs.gap) || 0;
        var row = 8;
        var heights = cards.map(function (el) {
          return el.getBoundingClientRect().height;
        });

        cards.forEach(function (el, i) {
          var span = Math.max(1, Math.ceil((heights[i] + gap) / (row + gap)));
          el.style.gridRowEnd = 'span ' + span;
        });
        grid.classList.add('rv__grid--masonry');
      });
    }

    function syncMeta(list) {
      if (emptyEl) emptyEl.hidden = list.length !== 0;
      if (moreWrap) moreWrap.hidden = list.length <= visible;
      if (shownEl) shownEl.textContent = Math.min(visible, list.length);
      if (totalEl) totalEl.textContent = list.length;
    }

    /* רינדור מלא · רק בשינוי סינון או מיון */
    function render() {
      var list = current();
      grid.innerHTML = list.slice(0, visible).map(card).join('');
      syncMeta(list);
      layoutMasonry();
    }

    /* הוספה בלבד · שומר על מיקום הגלילה */
    function appendMore(from, to) {
      var list = current();
      var frag = document.createElement('div');
      frag.innerHTML = list.slice(from, to).map(function (r, n) { return card(r, from + n); }).join('');
      var added = Array.prototype.slice.call(frag.children);
      added.forEach(function (el) {
        el.classList.add('rv__card--new');
        grid.appendChild(el);
      });
      requestAnimationFrame(function () {
        added.forEach(function (el, n) {
          el.style.transitionDelay = Math.min(n * 45, 360) + 'ms';
          el.classList.add('in');
        });
      });
      setTimeout(function () {
        added.forEach(function (el) {
          el.classList.remove('rv__card--new', 'in');
          el.style.transitionDelay = '';
        });
        layoutMasonry();
      }, 900);
      syncMeta(list);
      layoutMasonry();
    }

    var busy = false;
    if (loadBtn) {
      loadBtn.addEventListener('click', function () {
        if (busy) return;
        busy = true;
        var from = visible;
        loadBtn.classList.add('is-busy');
        loadBtn.disabled = true;
        setTimeout(function () {
          visible += STEP;
          appendMore(from, visible);
          loadBtn.classList.remove('is-busy');
          loadBtn.disabled = false;
          busy = false;
        }, LOAD_MS);
      });
    }

    /* ── תפריט ── */
    function closeDd() {
      if (!dd) return;
      dd.classList.remove('open');
      if (ddPanel) ddPanel.hidden = true;
      if (ddBtn) ddBtn.setAttribute('aria-expanded', 'false');
    }
    function syncLabel() {
      if (!ddLabel) return;
      var f = root.querySelector('[data-rv-filter].on');
      var o = root.querySelector('[data-rv-sort].on');
      if (filter !== '0' && f) ddLabel.textContent = f.childNodes[0].textContent.trim();
      else if (sort !== 'd' && o) ddLabel.textContent = o.childNodes[0].textContent.trim();
      else ddLabel.textContent = CFG.base;
    }
    if (ddBtn && ddPanel) {
      ddBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = dd.classList.toggle('open');
        ddPanel.hidden = !open;
        ddBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      ddPanel.addEventListener('click', function (e) { e.stopPropagation(); });
      document.addEventListener('click', closeDd);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDd(); });
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-rv-filter]'), function (b) {
      b.addEventListener('click', function () {
        filter = b.getAttribute('data-rv-filter');
        visible = INITIAL;
        Array.prototype.forEach.call(root.querySelectorAll('[data-rv-filter]'), function (x) {
          x.classList.toggle('on', x === b);
        });
        render(); syncLabel(); closeDd();
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-rv-sort]'), function (b) {
      b.addEventListener('click', function () {
        sort = b.getAttribute('data-rv-sort');
        visible = INITIAL;
        Array.prototype.forEach.call(root.querySelectorAll('[data-rv-sort]'), function (x) {
          x.classList.toggle('on', x === b);
        });
        render(); syncLabel(); closeDd();
      });
    });

    /* ── טופס ביקורת ── */
    var modal = root.querySelector('[data-rv-modal]');
    if (modal) {
      var fName = modal.querySelector('[data-rv-fname]');
      var fTitle = modal.querySelector('[data-rv-ftitle]');
      var fBody = modal.querySelector('[data-rv-fbody]');
      var charsEl = modal.querySelector('[data-rv-chars]');
      var pickTxt = modal.querySelector('[data-rv-picktxt]');
      var submit = modal.querySelector('[data-rv-submit]');
      var noteEl = modal.querySelector('[data-rv-note]');
      var starBtns = Array.prototype.slice.call(modal.querySelectorAll('[data-rv-star]'));
      var fAnon = modal.querySelector('[data-rv-anon]');
      var pick = 0;

      function paintStars(n) {
        starBtns.forEach(function (b) {
          b.classList.toggle('on', parseInt(b.getAttribute('data-rv-star'), 10) <= n);
        });
        if (pickTxt) pickTxt.textContent = n ? n + '/5' : F.notPicked;
      }
      function isAnon() { return !!(fAnon && fAnon.checked); }

      function syncAnon() {
        if (!fName) return;
        if (isAnon()) {
          if (fName.value !== F.anonName) fName.dataset.prev = fName.value;
          fName.value = F.anonName;
          fName.disabled = true;
        } else {
          fName.disabled = false;
          if (fName.value === F.anonName) fName.value = fName.dataset.prev || '';
        }
        checkValid();
      }

      function checkValid() {
        if (!submit) return;
        var nameOk = isAnon() || (fName && fName.value.trim().length > 1);
        var ok = pick > 0 && fBody && fBody.value.trim().length > 2 && nameOk;
        submit.disabled = !ok;
      }
      starBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          pick = parseInt(b.getAttribute('data-rv-star'), 10);
          paintStars(pick);
          checkValid();
        });
      });
      if (fBody) {
        fBody.addEventListener('input', function () {
          if (charsEl) charsEl.textContent = fBody.value.length;
          checkValid();
        });
      }
      if (fName) fName.addEventListener('input', checkValid);
      if (fAnon) fAnon.addEventListener('change', syncAnon);

      function openModal() {
        if (formH) formH.textContent = mine ? F.editTitle : F.newTitle;
        if (submitTxt && !sending) submitTxt.textContent = mine ? F.updateBtn : F.submitBtn;
        if (mine) {
          pick = mine.r || 0;
          if (fAnon) fAnon.checked = !!mine.a;
          if (fName) {
            fName.value = mine.n || '';
            fName.disabled = !!mine.a;
          }
          if (fTitle) fTitle.value = mine.h || '';
          if (fBody) fBody.value = mine.t || '';
          if (charsEl) charsEl.textContent = (mine.t || '').length;
        }
        paintStars(pick);
        checkValid();
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }
      function closeModal() {
        modal.hidden = true;
        document.documentElement.style.overflow = '';
        if (noteEl) noteEl.hidden = true;
      }
      root.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-rv-open]') : null;
        if (b && root.contains(b)) openModal();
      });
      Array.prototype.forEach.call(modal.querySelectorAll('[data-rv-close]'), function (b) {
        b.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });

      var sending = false;
      var submitTxt = modal.querySelector('[data-rv-submitxt]');
      var formH = modal.querySelector('[data-rv-formh]');
      var formWrap = modal.querySelector('[data-rv-form]');
      var stateEl = modal.querySelector('[data-rv-state]');
      var stateTxt = modal.querySelector('[data-rv-statetxt]');
      var closeX = modal.querySelector('.rv__modal-x');
      var closeBg = modal.querySelector('.rv__modal-bg');
      function lockClose(on) {
        if (closeX) closeX.hidden = on;
        if (closeBg) closeBg.style.pointerEvents = on ? 'none' : '';
      }

      if (submit) {
        submit.addEventListener('click', function () {
          if (submit.disabled || sending) return;
          sending = true;
          var wasEdit = !!mine;
          submit.disabled = true;
          lockClose(true);
          if (formWrap) formWrap.hidden = true;
          if (stateEl) {
            stateEl.hidden = false;
            stateEl.classList.remove('is-done');
          }
          if (stateTxt) stateTxt.textContent = F.sendingTxt;

          mine = {
            n: isAnon() ? F.anonName : fName.value.trim(),
            a: isAnon() ? 1 : 0,
            h: fTitle ? fTitle.value.trim() : '',
            t: fBody.value.trim(),
            r: pick,
            d: new Date().toISOString().slice(0, 10)
          };
          try { localStorage.setItem(KEY, JSON.stringify(mine)); } catch (e) {}
          hasMine = true;

          if (F.sendReal) {
            try {
              var fd = new FormData();
              fd.append('form_type', 'contact');
              fd.append('utf8', '\u2713');
              fd.append('contact[name]', mine.n);
              fd.append('contact[body]',
                F.subject + '\n' +
                'Valoración: ' + mine.r + '/5\n' +
                (mine.h ? 'Título: ' + mine.h + '\n' : '') +
                mine.t);
              fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
                .catch(function () {});
            } catch (e) {}
          }

          setTimeout(function () {
            if (stateEl) stateEl.classList.add('is-done');
            if (stateTxt) stateTxt.textContent = wasEdit ? F.updatedTxt : F.sentTxt;

            setTimeout(function () {
              applyMine();
              visible = Math.max(visible, INITIAL);
              filter = '0';
              sort = 'd';
              Array.prototype.forEach.call(root.querySelectorAll('[data-rv-filter]'), function (x) {
                x.classList.toggle('on', x.getAttribute('data-rv-filter') === '0');
              });
              Array.prototype.forEach.call(root.querySelectorAll('[data-rv-sort]'), function (x) {
                x.classList.toggle('on', x.getAttribute('data-rv-sort') === 'd');
              });
              render();
              syncOpenLabel();
              closeModal();

              if (stateEl) {
                stateEl.hidden = true;
                stateEl.classList.remove('is-done');
              }
              if (formWrap) formWrap.hidden = false;
              if (submitTxt) submitTxt.textContent = F.updateBtn;
              if (formH) formH.textContent = F.editTitle;
              lockClose(false);
              submit.disabled = false;
              sending = false;

              var first = grid.querySelector('.rv__card--mine');
              if (first && first.scrollIntoView) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, F.doneMs);
          }, F.sendMs);
        });
      }

      function syncOpenLabel() {
        var l = root.querySelector('[data-rv-openlabel]');
        if (l) l.textContent = mine ? F.editCta : F.ctaLabel;
      }
      syncOpenLabel();
      if (hasMine) render();
    }

    /* חישוב מחדש אחרי טעינת תמונות ובשינוי רוחב המסך. */
    grid.addEventListener('load', function (e) {
      if (e.target && e.target.tagName === 'IMG') layoutMasonry();
    }, true);
    var resizeTimer = 0;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layoutMasonry, 120);
    });
    layoutMasonry();

    /* ── תצוגת תמונה ── */
    if (lb && lbImg) {
      root.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-rv-zoom]') : null;
        if (!b || !root.contains(b)) return;
        lbImg.src = b.getAttribute('data-rv-zoom');
        lb.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      });
      var closeLb = function () {
        lb.hidden = true;
        lbImg.src = '';
        document.documentElement.style.overflow = '';
      };
      Array.prototype.forEach.call(root.querySelectorAll('[data-rv-lbclose]'), function (b) {
        b.addEventListener('click', closeLb);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) closeLb(); });
    }
  })();
